import { Field, FieldArray, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, FormGroup } from "reactstrap";
import { connect } from "react-redux";
import { upadteVendorAccountDetailsRequest } from "../../../redux/frontend/profile/action";
import { getValueByKey } from "../../../utils/authUtils";
import { commonConfirmBox } from "../../../helper/messagehelpers";

function AddEditAccountInfo({
  hraMemberId,
  setEditAccountNum,
  upadteVendorAccountDetailsRequest,
  vendorNumbers,
  vendorProfile,
}) {

  const handleSubmit = async (values) => {
    const response = await commonConfirmBox(
      "Are you sure you want to update the vendor account number?"
    );
    if (response) {
      const updatedValues = {
        isAdmin:true,
        hraMemberId: hraMemberId,
        ...values,
      };
      upadteVendorAccountDetailsRequest(updatedValues);
      setEditAccountNum(false);
    }
  };
  const [vendorDetails, setVendorDetails] = useState([]);
  useEffect(() => {
    if (vendorProfile?.length > 0) {
      const updatedVendorDetails = vendorProfile.map((x, index) => {
        const { apiName, id } = x;
        let accNumber = vendorNumbers.find((item) => item.apiKey === apiName);

        if (!accNumber) {
          accNumber = {
            id: id,
            apiKey: apiName,
            accNumber: null,
          };
        } else {
          accNumber = {
            id: id,
            apiKey: apiName,
            accNumber: accNumber?.accNumber,
          };
        }
        return accNumber;
      });

      setVendorDetails(updatedVendorDetails);
    }
  }, [vendorProfile, vendorNumbers]);

  return (
    <>
      <Formik
        initialValues={{
          vendorNumbers: vendorDetails,
        }}
        enableReinitialize={true}
        onSubmit={handleSubmit}
      >
        {({ values, isSubmitting, setFieldValue }) => {
          return (
            <Form className="row ">
              <div className="mb-2 d-flex align-items-center">
                <h6 className="separate-head">Vendors Account Number</h6>
                <div className="d-flex gap-2">
                  <Button
                    color="secondary"
                    size="sm"
                    title="Edit"
                    outline
                    type="button"
                    onClick={() => setEditAccountNum(false)}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    size="sm"
                    className="btn"
                    color="primary"
                    title="Edit"
                  >
                    Save
                  </Button>
                </div>
              </div>
              <FieldArray name="vendorNumbers">
                {({ push, remove }) => (
                  <>
                    {values.vendorNumbers?.map((x, index) => {
                      const { accNumber, apiKey, id } = x;

                      return (
                        <div className="col-3" key={index}>
                          <div className="hra-form-box">
                            <FormGroup className="m-0">
                              <label>{apiKey.replace(/_/g, " ")} #</label>
                              <span>
                                <Field
                                  id={apiKey}
                                  placeholder={apiKey?.replace(/_/g, " ")}
                                  className="form-control m-0 mt-1 form-control-sm h-auto"
                                  type="text"
                                  name={`vendorNumbers[${index}].accNumber`}
                                  value={accNumber ? accNumber : ""}
                                />
                              </span>
                            </FormGroup>
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </FieldArray>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
const mapStateToProps = ({ }) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    upadteVendorAccountDetailsRequest: (data) =>
      dispatch(upadteVendorAccountDetailsRequest(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddEditAccountInfo);
